export default "__VITE_ASSET__xbdbqAf4__"